import React, { useState } from 'react'
import styled from 'styled-components';
import { ArrowBigIcon } from '../../../../Icons/ArrowBigIcon'
import { getLanguageValue } from '../../../../../utils/getLanguageValue'
import { colors } from '../../../../../styles/colors';
import { useArticleDataState } from '../../../../../stores/Configuration/ArticleDataProvider'

const StyledSizeSystem = styled.div`
  position:relative;
  padding: 1rem;
  margin:2px;
  background:${colors.gray6};
  `
const SizeSystemCard = ({ sizeSystem, open, handleOpen }) => {
  const { actionMode, changeSizeSystemByKey } = useArticleDataState()
  const sizeSystemName = getLanguageValue(sizeSystem.internalName.values)
  const [sizeSystemIsSelected, setSizeSystemIsSelected] = useState(sizeSystem.isSelected ?? false)
  const updateCheckboxIsSelected = (e) => {
    const { target } = e;
    changeSizeSystemByKey(sizeSystem.id, "isSelected", target.checked)
    setSizeSystemIsSelected(target.checked)
  }
  const renderCheckBox = () => {
    return (actionMode === 'copy' &&
      <span>
        <input type="checkbox" id={`isSelected-${sizeSystem.id}`} name="scales"
          checked={sizeSystemIsSelected} onChange={(e) => updateCheckboxIsSelected(e)}>
        </input>
      </span>
    )
  }
  return (
    <StyledSizeSystem data-id={sizeSystem.id}>
      <div className="d-flex align-items-center">
        {sizeSystem.sizes.length ? <span role="button" className='d-flex' onClick={handleOpen}>
          <ArrowBigIcon variant={open ? 'down' : 'right'} />
        </span>
          : null}
        {renderCheckBox()}
        <h4 className="ps-2 mb-0">{sizeSystemName}</h4>
      </div>
    </StyledSizeSystem>
  )
}

export default SizeSystemCard